<template>
	<div class="figure-box">
		<Breadcrumb :crumb="crumb"></Breadcrumb>
		<div class="figure">
			<div class="left">
				<div class="item-box">
					<div class="title flex align-center justify-between">
						<span>个人信息</span>
					</div>
					<div class="input-item-box">
						<div class="input-item">
							<div class="name">姓名</div>
							<input placeholder="请输入您的姓名" name="name" :value="form_data.profile.name" @input="update_profile($event)" disabled />
						</div>
						<div class="input-item">
							<div class="name">性别</div>
							<div class="radio-box" style="line-height: 42px;">
								<RadioGroup  name="sex" :value="form_data.profile.sex"  @on-change="update_sex($event)"   >
									<Radio :label="1" :disabled="true">
										<span>男</span>
									</Radio>
									<Radio :label="2" :disabled="true" >
										<span>女</span>
									</Radio>
								</RadioGroup>
							</div>
						</div>
						<div class="input-item">
							<div class="name">年龄</div>
							<input placeholder="请输入您的生日" type="date" name="birthday" :value="form_data.profile.birthday" @input="update_profile($event)" :disabled="true" />
						</div>
					</div>
					<div class="input-item-box">
						<div class="input-item">
							<div class="name">手机</div>
							<input placeholder="请输入您的手机号" name="mobile" :value="form_data.profile.mobile" @input="update_profile($event)"  :disabled="true" />
						</div>
						<div class="input-item">
							<div class="name">身高</div>
							<input placeholder="请输入您的身高（厘米）" name="height" :value="form_data.profile.height" @input="update_profile($event)"  :disabled="true" />
						</div>
						<div class="input-item">
							<div class="name">体重</div>
							<input placeholder="请输入您的体重（公斤）" name="weight" :value="form_data.profile.weight" @input="update_profile($event)"  :disabled="true" />
						</div>
					</div>
					<div class="input-item-box">
						<div class="input-item" style="margin-bottom: 10px;">
							<div class="name">身体体型</div>
							<Radio-group name="somatotype" :value="form_data.somatotype" style="margin-left:20px"  @on-change="update_somatotype($event)" >
								<Radio :label="'Y'">
									<span>Y型&nbsp;&nbsp;&nbsp;</span>
								</Radio>
								<Radio :label="'A'">
									<span>A型&nbsp;&nbsp;&nbsp;</span>
								</Radio>
								<Radio :label="'B'">
									<span>B型&nbsp;&nbsp;&nbsp;</span>
								</Radio>
								<Radio :label="'C'">
									<span>C型&nbsp;&nbsp;&nbsp;</span>
								</Radio>
								<Radio :label="'D'">
									<span>D型&nbsp;&nbsp;&nbsp;</span>
								</Radio>
								<Radio :label="'E'">
									<span>E型&nbsp;&nbsp;&nbsp;</span>
								</Radio>
							</Radio-group>
						</div>
					</div>
					<div class="input-item-box">
						<div class="input-item" style="margin-bottom: 10px;">
							<div class="name">穿衣偏好</div>
							<Radio-group name="clothes_preference" :value="form_data.clothes_preference" style="margin-left:20px" @on-change="update_clothes_preference($event)">
								<Radio :label="2">
									<span>紧身版</span>
								</Radio>
								<Radio :label="1">
									<span>合体版</span>
								</Radio>
								<Radio :label="4">
									<span>标准版</span>
								</Radio>
								<Radio :label="3">
									<span>宽松版</span>
								</Radio>
							</Radio-group>
						</div>
					</div>
					<div class="input-item-box">
						<div class="input-item" style="margin-bottom: 10px;">
							<div class="name">量尺方式</div>
							<Radio-group name="clothes_preference" :value="form_data.measure_type" style="margin-left:20px" @on-change="update_measure_type($event)">
								<Radio :label="1" :disabled="true">
									<span>净体量尺</span>
								</Radio>
								<Radio :label="2" :disabled="true">
									<span>成衣量尺</span>
								</Radio>
							</Radio-group>
						</div>
					</div>
				</div>

				<transition name="fade">
					<div class="item-box" v-show="form_data.measure_type==1">
						<div class="title">量体信息</div>
						<div class="table-wrap">
							<div class="input-box" v-for="(item, key) in net_param_list" :key="'netsize-'+key">
								<div class="input-title">{{item.field_name_cn}}</div>
								<span class="input">
								<input
										class="input"
										type="text"
										:value="net_size[item.field_key]"
										@input="update_size($event, item.field_key, 'net_size')"
										placeholder="净"
								/>
							</span>
							</div>
							<div class="clear"></div>
						</div>
					</div>
				</transition>


				<div class="item-box">
					<div class="title">体态特征</div>
					<div class="body-box">
						<div class="body-item" v-for="(item,index) in body_list" :key="index">
							<div class="name">{{ item.field_name_cn }}</div>
							<div class="img-list">
								<div class="img-box" @click="update_body_feature(item.field_key,oitem.text)"
									v-for="(oitem,oindex) in item.option_list" :key="oindex"
									:class="isActiveBody(item.field_key,oitem.text) ? 'select-active':''">
									<img :src="oitem.image" />
									<div class="value"> {{ oitem.text }} </div>
								</div>
								<div class="clear"></div>
							</div>
						</div>
						<div class="clear"></div>
					</div>
				</div>
			</div>
			<div class="right">
				<div class="title">订单确认</div>
				<div class="goods">
					<img :src="category.main_image" />
					<div class="content">
						<div class="p-name">{{category.category_name_cn}}</div>

					</div>
				</div>
				<div class="order">
					<div class="main-color">成衣信息</div>
					<div class="item" v-for="(item,index) in complete_param_list" :key="'complete-size-'+index">
						<span class="label">{{ item.field_name_cn }}</span>
						<input
								class="input"
								type="text"
								:value="complete_size[item.field_key]"
								@input="update_size($event, item.field_key, 'complete_size')"
								placeholder=""
						/>cm
					</div>
					<div class="main-color">体态特征</div>
					<div class="item" v-for="item in body_list" :key="'body-' + item.field_key">
						<span class="label">{{ item.field_name_cn }}</span>
						<span class="value">{{ getBodyValue(item.field_key) || '未选择'}}</span>
					</div>
				</div>
				<div class="pay" @click="go2checkout">保存订单量体</div>
			</div>
			<div class="clear"></div>
		</div>

	</div>

</template>

<script>
	import {mapState} from 'vuex';
	import Breadcrumb from "@/components/Breadcrumb.vue";
	import {getFigureCustomers, checkFigureMobile, getFigureMeta, getBodyMeta, getOrderDetail, reviseOrderFigure} from "@/api"
	import {oss} from '@/utils/aliyunoss.js'
	import CalculatorManager from '@/utils/rule/Manager'
	export default {
		name: "OrderFigure",
		components: {
			Breadcrumb
		},
		data() {
			return {
				crumb: [{
					title: "私人定制",
					path: "Category",
				}],
				num: 1,
				net_param_list: [],
				body_param_list: [],
				calculator: null,
			};
		},
		computed: {
			...mapState({
				category: (state) => state.mtm.picked_category,
				complete_param_list: (state) => state.mtm.picked_category.figure,
				body_list: (state) => state.mtm.picked_category.body,
				form_data: (state) => {
					let {profile, clothes_preference, measure_type, somatotype, net_size, complete_size, body_feature, body_size} = state.mtm.form_data
					return {profile, clothes_preference, measure_type, somatotype, net_size, complete_size, body_feature, body_size}
				},
				net_size: (state) => {return state.mtm.form_data.net_size},
				complete_size: (state) => {return state.mtm.form_data.complete_size},
				body_feature: (state) => {return state.mtm.form_data.body_feature},
			}),
		},
		watch: {
			'form_data.profile.height': function (val, oldVal) {
				this.calculator.setHW(this.form_data.profile.height, this.form_data.profile.weight )
				this.update_somatotype(this.calculator.getDefaultSomatotype())
				this.update_category_size()
			},
			'form_data.profile.weight': function (val, oldVal) {
				this.calculator.setHW(this.form_data.profile.height, this.form_data.profile.weight )
				this.update_somatotype(this.calculator.getDefaultSomatotype())
				this.update_category_size()
			},
			'form_data.clothes_preference': function (val, oldVal) {
				this.update_category_size()
			},
			'form_data.somatotype': function (val, oldVal) {
				this.update_category_size()
			},
			net_size: {
				deep: true,
				handler: function (val, oldVal) {
					this.calculator.setNetSize(val)
					this.update_category_size()
				}
			},
			body_feature: {
				deep: true,
				handler: function (val, oldVal) {
					this.calculator.setBodySize(val)
					this.update_category_size()
				}
			},
		},
		mounted() {
			getFigureMeta().then((response) => {
				this.net_param_list = response.data
			})
			this.$emit('showLogin', true)
			this.$emit('showBack', true)
			this.$emit('showNav', false)
			this.$emit('showFooter', true)
		},
		methods: {
			update_profile(e) {
				this.$store.commit('mtm/update_profile', {
					key: e.target.name,
					value: e.target.value,
				})
			},
			update_sex(e) {
				this.$store.commit('mtm/update_profile', {
					key: 'sex',
					value: e,
				})
			},
			update_clothes_preference(e) {
				this.$store.commit('mtm/update_clothes_preference', e)
			},
			update_measure_type(e) {
				this.$store.commit('mtm/update_measure_type', e)
			},
			update_somatotype(e) {
				this.$store.commit('mtm/update_somatotype', e)
				this.calculator.setCustomSomatotype(e)
			},
			update_size(e, key, type_name) {
				this.$store.commit('mtm/update_size', {
					type_name,
					key,
					value: e.target.value
				})
			},
			update_body_feature(name, desc) {
				this.$store.commit('mtm/update_body_feature', {
					body: name,
					feature: desc
				})
				this.calculator.setBodySize({...this.form_data.body_feature, [name]: desc})
			},
			getBodyValue(key) {
				return this.form_data.body_feature[key]
			},
			isActiveBody(field_key, text) {
				if (this.form_data.body_feature[field_key] == text) {
					return true
				}
				return false
			},
			go2checkout() {
				reviseOrderFigure({
					order_id: this.$route.query.id,
					form_data: this.form_data
				}).then(response => {
					this.$Notice.success({
						title: "修改成功"
					})
					this.$router.go(-1)
				})
			},
			// 因身高/体重/穿衣偏好/体型选择变动导致的成衣尺寸重新计算
			update_category_size() {
				this.calculator.setHW(this.form_data.profile.height, this.form_data.profile.weight)
				this.calculator.setNetSize(this.form_data.net_size)
				let complete_list = this.calculator.getCompleteSize(String(this.form_data.clothes_preference))
				for (let key in complete_list) {
					this.update_size({
						target: {
							value: complete_list[key]
						}
					}, key, 'complete_size')
				}
				let body_list = this.calculator.getBodySize()
				for (let key in body_list) {
					this.$store.commit('mtm/update_size', {
						type_name: 'body_size',
						key,
						value: body_list[key]
					})
				}
			},
		},
		created() {
			getOrderDetail({
				order_id: this.$route.query.id
			}).then((response) => {
				console.log(response)
				let design_data = response.data.design_mtm.design_data
				this.$store.commit('mtm/pick', {category: design_data.category})
				this.calculator = CalculatorManager.factory(this.category.style_no)

				let clothes_preference = design_data.clothes_preference
				let measure_type = design_data.measure_type
				let figure_body = {
					body_feature: design_data.body_feature,
					net_size: design_data.net_size
				}
				let profile = {
					name: design_data.profile.name,
					sex: design_data.profile.sex,
					birthday: design_data.profile.birthday,
					mobile: design_data.profile.mobile,
					height: design_data.profile.height,
					weight: design_data.profile.weight,
				}
				for (let key in profile) {
					this.update_profile({
						target: {
							name: key,
							value: profile[key]
						}
					})
				}
				this.update_clothes_preference(clothes_preference)
				this.$store.commit('mtm/update_measure_type', measure_type)
				for (let key in figure_body.body_feature) {
					this.update_body_feature(key, figure_body.body_feature[key])
				}
				this.$store.commit('mtm/reset_size', {type_name: 'net_size'})
				for (let key in figure_body.net_size) {
					this.update_size({
						target: {
							value: figure_body.net_size[key]
						}
					}, key, 'net_size')
				}
			})
		}
	};
</script>

<style scoped lang="scss">
	.figure-box {
		width: 1170px;
		margin: 20px auto;
	}

	.figure {
		margin-top: 20px;
		margin-bottom: 50px;
	}

	.left {
		float: left;
		.item-box {
			width: 870px;
			background: #ffffff;
			box-shadow: 0px 2px 23px rgba(0, 0, 0, 0.07);
			border-radius: 5px;
			padding: 0 20px;
			margin-bottom: 20px;

			.body-box {
				margin: 20px 0;

				.body-item {
					display: flex;
					width: 800px;
					align-items: center;
					margin-bottom: 10px;

					.name {
						width: 68px;
						font-size: 14px;
						font-weight: bold;
						line-height: 59px;
					}

					.img-list {
						display: flex;
						.img-box {
							text-align: center;
							margin-left: 12px;

							img {
								width: 100px;
								height: 100px;
								border-radius: 7px;
							}

							.value {
								font-size: 12px;
								font-weight: 400;
								color: #000000;
								margin-top: 5px;
							}
						}
					}
				}
			}

			textarea {
				height: 80px;
				background: #F3F4F5;
				opacity: 1;
				border-radius: 5px;
				padding: 10px;
				width: 100%;
				border: none;
				margin: 20px 0;
			}

			.title {
				height: 52px;
				line-height: 52px;
				border-bottom: 1px solid #e9e9e9;
				color: #0f114a;
				font-size: 16px;
				font-weight: bold;
			}

			.input-item-box {
				margin-top: 20px;
				display: flex;
				height: 42px;

				.input-item {
					display: flex;
					align-items: center;
				}

				.name {
					font-size: 15px;
					font-weight: bold;
					color: #000000;
					min-width: 30px;
				}

				.radio-box,
				input {
					width: 214px;
					height: 42px;
					border-bottom: 1px solid #dddddd;
					border-top: none;
					border-left: none;
					border-right: none;
					margin: 0 20px;
					padding-left: 10px;
				}
			}
		}
	}

	.right {
		margin-left: 30px;
		width: 270px;
		background: #ffffff;
		box-shadow: 0px 2px 23px rgba(0, 0, 0, 0.07);
		padding: 0 20px;
		float: left;
		.title {
			font-size: 16px;
			font-family: PingFang SC;
			font-weight: bold;
			line-height: 22px;
			color: #000000;
			height: 52px;
			line-height: 52px;
			border-bottom: 1px solid #e9e9e9;
			text-align: center;
		}

		.goods {
			padding-top: 10px;
			display: flex;

			img {
				width: 80px;
				height: 80px;
			}

			.content {
				margin-left: 10px;

				.p-name {
					font-size: 15px;
					font-weight: bold;
					color: #000000;
					height: 60px;
				}

				.number-box {
					height: 20px;
					border: 1px solid #999999;
					display: flex;
					align-items: center;

					.minus,
					.plus {
						width: 27px;
						cursor: pointer;
						color: #707070;
						line-height: 27px;
						text-align: center;
						font-size: 18px;
					}

					.num {
						border-top: none;
						border-bottom: none;
						border-left: 1px solid #999999;
						border-right: 1px solid #999999;
						width: 27px;
						text-align: center;
						color: #000000;
					}
				}
			}
		}

		.order {
			padding-bottom: 10px;

			.main-color {
				font-size: 16px;
				font-weight: bold;
				color: #0f114a;
				margin: 20px 0 10px;
			}

			.item {
				display: flex;
				justify-content: space-between;
				align-items: center;
				border-bottom: 1px solid #dddddd;
				height: 44px;

				span.label {
					width: 60px;
					font-size: 13px;
					font-weight: bold;
					color: #333333;
					text-align: right;
				}

				.value {
					font-weight: 400;
					color: #666666;
				}

				.input {
					width: 80px;
					height: 30px;
					line-height: 30px;
					background: #FFFFFF;
					margin-left: 10px;
					text-align: center;
					border: none;
				}
			}
		}

		.total {
			height: 44px;
			display: flex;
			justify-content: space-between;
			align-items: center;

			span {
				font-size: 15px;
				font-weight: bold;
				color: #333333;
			}

			.price {
				font-weight: 400;
				color: #0f114a;
			}
		}

		.pay {
			width: 230px;
			height: 44px;
			line-height: 44px;
			background: #0f114a;
			opacity: 1;
			border-radius: 2px;
			text-align: center;
			font-size: 16px;
			font-weight: bold;
			color: #edd4ac;
			margin-top: 30px;
			cursor: pointer;
			margin-bottom: 20px;
		}
	}

	.select-active {
		position: relative;
	}

	.select-active:after {
		background-image: url("../../assets/images/design/select@2x.png");
		background-size: 100%;
		width: 13px;
		height: 13px;
		position: absolute;
		right: 5px;
		top: 5px;
		content: "";
	}

	.table-wrap {

		.input-box {
			width: 166px;
			height: 60px;
			float: left;
			display: flex;
			align-items: center;
			padding: 20px 10px;

			.input-title {
				width: 60px;
				font-size: 14px;
				font-weight: bold;
				color: #000000;
				text-align: right;
			}

			.input {
				width: 80px;
				height: 30px;
				line-height: 30px;
				background: #FFFFFF;
				margin-left: 10px;
				text-align: center;
			}
		}
	}
	.upload-list {
		display: inline-block;
		margin-right: 10px;

		.profile-image-wrap {
			display: inline-block;
			position: relative;
			.profile-image-icon {
				position: absolute;
				top: -10px;
				right: 0;
				font-size: 20px;
				z-index: 100;
			}
		}

		img {
			margin: 0 10px;
		}
	}

</style>
